import * as React from 'react'
import { FC, PropsWithChildren } from 'react'

import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import { cls } from '../../utils/utils'
import ScrollToTopButton from '../ScrollToTopButton/ScrollToTopButton'
import styles from './Layout.module.scss'
import { ILayout } from './Layout.types'

const Layout: FC<PropsWithChildren<ILayout>> = ({ children, backgroundColor, headerLink, dottedRectanglesClassName }) => {
  return (
    <>
      <Header headerLink={headerLink} />
      <main className={cls(styles.main, backgroundColor && styles[backgroundColor])}>{children}</main>
      <Footer dottedRectanglesClassName={dottedRectanglesClassName} />
      <ScrollToTopButton />
    </>
  )
}

export default Layout
